<template>
  <AppLayout>
<template #subheader>
  <button
    class="btn btn-sm btn-outline-secondary d-lg-none mb-2"
    type="button"
    @click="isFilterOpen = true">
    Filtry
  </button>
  <div
    v-if="isFilterOpen"
    class="offcanvas-backdrop fade show"
    @click="isFilterOpen = false">
  </div>
  <div class="mobile-filter-panel" :class="{ show: isFilterOpen }">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Filtry</h5>
      <button
        class="btn-close"
        @click="isFilterOpen = false">
      </button>
    </div>
    <div class="d-flex flex-column gap-3">
      <div>
        <label class="mb-1">Projekt:</label>
        <select
          class="form-select form-select-sm"
          v-model="selectedProjectId"
          @change="updateSelectedProject">
          <option value="0">Wszystkie projekty</option>
          <option
            v-for="project in projects"
            :key="project.id"
            :value="project.id">
            {{ project.label }}
          </option>
        </select>
      </div>
      <div>
        <label class="mb-1">Zespół:</label>
        <select
          class="form-select form-select-sm"
          v-model="selectedTeamName"
          @change="updateSelectedTeam"
          :disabled="!selectedProjectId || (teams && teams.length === 0)">
          <option value="">Wszystkie</option>
          <option
            v-for="team in teams"
            :key="team.name"
            :value="team.name">
            {{ team.name }}
          </option>
        </select>
      </div>
		<div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="showSend"
            @change="changeShowSend()">
          <label class="form-check-label">
            Pokaż wszystkie
          </label>
        </div>
    </div>
  </div>
  <div class="d-none d-lg-flex align-items-start justify-content-between flex-nowrap gap-3">
    <div class="d-flex align-items-center gap-3 flex-nowrap">
      <div class="d-flex align-items-center gap-2">
        <label class="mb-0">Projekt:</label>
        <select
          class="form-select form-select-sm"
          v-model="selectedProjectId"
          @change="updateSelectedProject"
          style="min-width: 260px; max-width: 500px;">
          <option value="0">Wszystkie</option>
          <option
            v-for="project in projects"
            :key="project.id"
            :value="project.id">
            {{ project.label }}
          </option>
        </select>
      </div>
      <div class="d-flex align-items-center gap-2">
        <label class="mb-0">Zespół:</label>
        <select
          class="form-select form-select-sm"
          v-model="selectedTeamName"
          @change="updateSelectedTeam"
          :disabled="!selectedProjectId || (teams && teams.length === 0)"
          style="width: 180px;">
          <option value="">Wszystkie</option>
          <option
            v-for="team in teams"
            :key="team.name"
            :value="team.name">
            {{ team.name }}
          </option>
        </select>
      </div>
	</div>
	<div class="d-flex align-items-center gap-3 flex-nowrap">
		<div class="form-check form-switch mb-0 flex-shrink-0">
		<input
		  class="form-check-input"
		  type="checkbox"
		  v-model="showSend"
		  @change="changeShowSend()">

		<label class="form-check-label ms-2">
		  Pokaż wszystkie
		</label>
		</div>
    </div>
  </div>
</template>


    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading d-block">
          <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.flash.errors">
            <li class="alert alert-danger">{{ error }}</li>
          </ul>
        </div>

        <div class="widget-content">
          <div>
            <ejs-grid ref="quoteListGrid" id="quoteListGridId" :height="quoteRequest?.id ? '40vh' : gridHeight"
                      :dataSource="quoteRequestsDataManager"
					  :rowHeight="32"
                      :allowTextWrap='false'
                      :allowExcelExport='true'
                      :allowPaging="true"
                      :allowSorting='true'
                      :allowFiltering='true'
                      :allowReordering='true'
                      :allowResizing='true'
                      :showColumnChooser='true'
                      :allowSelection='true'
					  :showCheckbox="true"
                      :enablePersistence='true'
                      :pageSettings="pageSettings"
                      :editSettings="editSettings"
                      :filterSettings="filterOptions"
                      :toolbar="toolbar"
					  :rowSelecting="rowSelecting"
                      :contextMenuItems="contextMenuItems"
                      :selectionSettings="selectionOptions"
                      :aggregates="aggregateOptions"
                      :toolbarClick="clickToolbarHandler"
                      :contextMenuClick="clickContextMenuHandler"
                      :actionBegin="actionBeginHandler"
                      :actionComplete="actionCompleteHandler"
                      @queryCellInfo="queryCellInfo"
                      :rowSelected="onRowSelected"
					  :recordClick="onRowClick"
					  :contextMenuOpen="onContextMenuOpen"
					  :headerCellInfo="headerCellInfoEvent "
                      :keyPressed="onKeyDown">
              <e-columns>
                <e-column type="number" headerText="L.p." width="70" :template="'indexTemplate'"
                          :allowEditing="false" :allowSorting="false" :allowFiltering="false"/>
				<e-column type="checkbox" width="100"/>
                <e-column field="id" headerText="ID" :allowEditing="false" :isPrimaryKey="true"
                          :visible="false"/>
                <e-column field="request_number" headerText="Zapytanie ofertowe" :allowEditing="false"
                          :filter="filterDefault" width="180" type="string"/>
                <e-column field="required_project_id" headerText="Z zapotrzebowania" :allowEditing="false"
                          :filter="filterDefault" type="string"/>
                <e-column field="required_project_was_edited_later" width="80"
                          headerTooltip="Wartość została zmieniona!" headerText="!"
                          :allowEditing="true" :allowFiltering="false" type="number" :edit="wasEditedLaterEdit"
                          editType="dropdownedit" :template="'wasEditedLaterTemplate'"/>
                <e-column field="project_number" headerText="Projekt" :allowEditing="false"
                          :filter="filterDefault" type="string"/>
                <e-column field="created_at" headerText="Data utworzenia" :allowEditing="false" format="dd.MM.yyyy"
                          :filter="filterDefault" type="date"/>
                <e-column field="deliverers" headerText="Wysłano do" :allowEditing="false"
                          :filter="filterDefault" type="string"/>
                <e-column field="sent_to_emails" headerText="Wysłano na maile" :allowEditing="false"
                          :filter="filterDefault" type="string"/>
                <e-column field="due_date" headerText="Termin odpowiedzi" :allowEditing="false"
                          :filter="filterDefault" format="dd.MM.yyyy" type="date"/>
                <e-column field="status" headerText="Status" :allowEditing="true" editType="dropdownedit" type="string"
                          :dataSource="allStatuses" :filter="filterStatuses" :edit="statusParams" :template="'statusWithColorTemplateIndex'"/>
                <e-column field="created_by" headerText="Utworzone przez" :allowEditing="false"
                          :filter="filterDefault"/>
                 <e-column field="delivery_date_deadline" headerText="Termin dostawy" :allowEditing="true"
                          format="dd.MM.yyyy" type="date" editType="datepickeredit"/>
                <e-column field="quoted_date" headerText="Data otrzymania wyceny" :allowEditing="true"
                          format="dd.MM.yyyy" type="date" editType="datepickeredit"/>
                <e-column field="comment" headerText="Komentarz" :allowEditing="true" :allowFiltering="false"
                          :filter="filterDefault"/>
                <e-column field="article_files" headerText="Załączniki art." width="200"
                          :template="'attachmentsTemplate'" :allowEditing="false" :allowFiltering="false"/>
                <e-column field="required_project_files" headerText="Załączniki Zapotrz." width="200"
                          :template="'attachmentsRequiredTemplate'" :allowEditing="false" :allowFiltering="false"/>
                <e-column field="files" headerText="Oferta" width="200"
                          :template="'attachmentsQuoteRequestTemplate'" :allowEditing="false" :allowFiltering="false"/>

                <template v-slot:deliverersShortNamesTemplate="{data}">
                  {{ formatDeliverers(data) }}
                </template>

              </e-columns>
			  <template v-slot:indexTemplate="{ data }">
				<span style="color:#a6a6a6">
				  {{ getRowIndex(data) }}
				</span>
			  </template>
              <template v-slot:wasEditedLaterTemplate="{data}">
                <span
                    v-if="data.required_project_was_edited_later"
                    style="color: white; background-color: orangered; font-size:16px; font-weight: 700; width: 20px; display: block; text-align: center">
                  !
                </span>
              </template>
                            <template v-slot:statusWithColorTemplateIndex="{ data }">
                                <div
                                    style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%;">
                                    <span v-if="data.bg_status_colors?.length" :style="{
                                        backgroundColor: data.bg_status_colors[0],
                                        width: '20px',
                                        height: '20px',
                                        display: 'inline-block',
                                        borderRadius: '4px',
                                        verticalAlign: 'middle',
                                        marginRight: '8px'
                                    }" :title="data.status"></span>
                                    <span style="vertical-align: middle;">
                                        {{ data.status }}
                                    </span>
                                </div>
                            </template>
              <e-aggregates>
                <e-aggregate>
                  <e-columns>
                    <e-column type="Sum" field="quoted_price" format="N2"
                              groupCaptionTemplate='Suma: ${Sum}'></e-column>
                  </e-columns>
                </e-aggregate>
              </e-aggregates>

              <template v-slot:attachmentsTemplate="{ data }">
                <div>
                  <a v-if="data.article_files && data.article_files.length" class="text-primary"
                     :href="route('articles.files.show', {file:data.article_files[0].id})"
                     target="_blank">
                    {{ data.article_files[0].original_name }}
                  </a>

                  <button class="ms-1 btn btn-xs btn-outline-default border"
                          @click="showAttachmentsModal(data.article_files)">+{{
                      Object.keys(data.article_files).length || ''
                    }}
                  </button>

                </div>
              </template>
              <template v-slot:attachmentsRequiredTemplate="{ data }">
                <div>
                  <a v-if="data.required_project_files && data.required_project_files.length" class="text-primary"
                     :href="route('requiredProjectItem.files.show', {file:data.required_project_files[0].id})"
                     target="_blank">
                    {{ data.required_project_files[0].original_name }}
                  </a>

                  <button class="ms-1 btn btn-xs btn-outline-default border"
                          @click="showRequiredAttachmentsModal(data.required_project_files)">+{{
                      Object.keys(data.required_project_files || []).length || ''
                    }}
                  </button>
                </div>
              </template>
              <template v-slot:attachmentsQuoteRequestTemplate="{ data }">
                <div>
                  <a v-if="data.files && data.files.length" class="text-primary"
                     :href="route('quoteRequests.files.show', {file:data.files[0].id})"
                     target="_blank">
                    {{ data.files[0].original_name }}
                  </a>

                  <button class="ms-1 btn btn-xs btn-outline-default border"
                          @click="showQuoteRequestAttachmentsModal(data)">+{{
                      Object.keys(data.files).length || ''
                    }}
                  </button>
                </div>
              </template>

            </ejs-grid>

            <SelectedQuoteRequestItem :quoteRequestId="quoteRequestId" :quoteRequest="quoteRequest"
                                      :allStatuses="allStatuses" :table_settings="table_settings_selected"
                                      :quoteRequestItemsStatus="quoteRequestItemsStatus"
                                      @refresh="refreshGrids()" :suppliers="suppliers" :producers="producers"
                                      :units="units" :order_where_list="order_where_list"
                                      :selectedProjectId="selectedProjectId" :selectedTeamName="selectedTeamName"/>
          </div>

        </div>
      </div>
    </div>

    <AddQuoteRequestItemsModal ref="addQuoteRequestRef" :project="selectedProjectId" :team="selectedTeamName"
                               :units="units" :suppliers="suppliers" :producers="producers" :order_where_list="order_where_list"  @added-success="successMsg" @added-error="errorMsg"
                               @added-article="refreshGrids()"/>

    <SendQuoteRequestModal v-if="selectedArticles" ref="sendQuoteRequestModalRef" :order_where_list="order_where_list" :selectedItems="selectedArticles" :units="units" @refresh="refreshGrids()"
                           @added-success="successMsg" @added-error="errorMsg" @clear-selection="clearSelection"/>

    <!-- Modal z dodawaniem załączników -->
    <ArticleFilesModal v-if="showFilesModal" :article="selectedArticle" @close="showFilesModal = false"
                       :can-add="false" :can-remove="false"
                       @refresh="this.$refs.quoteListGrid.refresh()" @added-success="successMsg"
                       @added-error="errorMsg"/>

    <RequiredProjectItemsFilesModal v-if="showRequiredFilesModal" :requiredProjectItem="selectedArticle"
                                    :can-add="false" :can-remove="false"
                                    @close="showRequiredFilesModal = false"
                                    @refresh="this.$refs.quoteListGrid.refresh()" @added-success="successMsg"
                                    @added-error="errorMsg"/>

    <QuoteRequestsFilesModal v-if="showQuoteRequestModal" :quoteRequests="selectedArticle"
                             @close="showQuoteRequestModal = false"
                             @refresh="this.$refs.quoteListGrid.refresh()" @added-success="successMsg"
                             @added-error="errorMsg"/>
							 
	<AddOrderModal v-if="showAddOrderModal" ref="addOrderModalRef" :project="selectedProjectId" :team="selectedTeamName"
                   :selectedItems="selectedRecordsToCreateOrder.slice()" :order_where_list="order_where_list" :negotiations="negotiations" :currencys="currencys" @added-success="successMsg" @added-error="errorMsg"
				   @clear-selection="clearSelection" @close="showAddOrderModal = false"/>
	
	<AddToOrderModal ref="addToOrderModalRef" :project="selectedProjectId" :team="selectedTeamName" :order_list="order_list"
		:selectedItems="selectedRecordsToCreateOrder.slice()" :order_where_list="order_where_list" :currencys="currencys" @added-success="successMsg" @added-error="errorMsg"
		@clear-selection="clearSelection"/>
  </AppLayout>
</template>

<script>
import AppLayout from "../../Layouts/App.vue";
import {useForm, usePage, router} from "@inertiajs/vue3";
import {AutoComplete, MultiSelect} from '@syncfusion/ej2-vue-dropdowns';
import AddOrderModal from "./AddOrderModal.vue";
import AddToOrderModal from "./AddToOrderModal.vue";
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Aggregate,
  Edit,
  ExcelExport,
  Filter, ForeignKey,
  GridComponent,
  AggregatesDirective,
  AggregateDirective,
  Page,
  Reorder,
  Resize,
  Sort,
  Toolbar,
} from '@syncfusion/ej2-vue-grids';
import {createElement} from "@syncfusion/ej2-base";
import {DataManager, Predicate, Query, WebMethodAdaptor} from '@syncfusion/ej2-data';
import {ComboBox, DropDownList} from "@syncfusion/ej2-dropdowns";
import moment from "moment";
import {ref} from "vue";
import AddQuoteRequestItemsModal from "./AddQuoteRequestItemsModal.vue";
import SendQuoteRequestModal from "./SendQuoteRequestModal.vue";
import SelectedQuoteRequestItem from "./SelectedQuoteRequestItem.vue";
import SelectedOrderItems from "../OrderLists/SelectedOrderItems.vue";
import RequiredProjectItemsFilesModal from "../RequiredProjectItems/RequiredProjectItemsFilesModal.vue";
import ArticleFilesModal from "../Warehouses/Articles/ArticleFilesModal.vue";
import QuoteRequestsFilesModal from "./QuoteRequestsFilesModal.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const {hasPermission} = usePermission();

let dropInstanceFilterUnits, statusElem, statusObj;
export default {

  components: {
    QuoteRequestsFilesModal,
	AddOrderModal,
	AddToOrderModal,
    ArticleFilesModal, RequiredProjectItemsFilesModal,
    SelectedOrderItems,
    SelectedQuoteRequestItem,
    AddQuoteRequestItemsModal,
    SendQuoteRequestModal,
    AppLayout,
    MultiSelect,
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
    "e-aggregates": AggregatesDirective,
    "e-aggregate": AggregateDirective
  },

  provide: {
    grid: [Page, Edit, Toolbar, ContextMenu, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ForeignKey, Aggregate]
  },

  props: {
    projects: Object,
    allStatuses: Object,
    quoteRequestItemsStatus: Object,
    suppliers: Object,
	producers: Object,
    order_where_list: Array,
    units: Object,
	order_list: Object,
	negotiations: {
        type: Array,
        default: () => [],
    },
	currencys: Object,
	table_settings: {
		type: Object,
		now_restore_table: {
				type: Number,
				default: 1
			},
		default: null
	},
	table_settings_selected: {
		type: Object,
		now_restore_table_items: {
			type: Number,
			default: 1
			},
		default: null
	},
	
  },
  mounted() {
	this.restoreTableIfNeeded();
  	this.calculateGridHeight();
    window.addEventListener('resize', this.calculateGridHeight);

  const gridEl = document.getElementById('quoteListGridId');

  if (gridEl) {
    gridEl.addEventListener('mousedown', (e) => {
      if (e.which === 3) {
        this.preventRightClickSelection = true;
      }
    });
  }
  
	},
	
  beforeMount() {

    // Odczytanie danych z sesji
    const storedProjectId = sessionStorage.getItem('selectedProjectId');
    const storedTeam = sessionStorage.getItem('selectedTeam');

    if (storedProjectId) {
      this.selectedProjectId = (storedProjectId === 'null' || storedProjectId === null) ? 0 : storedProjectId;
      this.updateTeams();
    }

    this.selectedTeamName = storedTeam;
    this.getQutoeRequestsForProject();
  },
beforeUnmount() {
    window.removeEventListener('resize', this.calculateGridHeight);

  },
  data() {
    return {
	hasTableSettings: false,
	 isFilterOpen: false,
	  showSend: false,
	 preventRightClickSelection: false,
	 selectedRecordsToCreateOrder: [],
	gridHeight: '64vh',
      hasPermission,
      shouldCollapseByInitial: true,
      teams: [],
      quoteRequestsDataManager: [],
      fetchedOrders: [],
      quoteRequestId: null,
      quoteRequest: null,
      selectedProjectId: null,
      selectedTeamName: null,
      showFilesModal: false,
	  showAddOrderModal: false,
      showRequiredFilesModal: false,
      showQuoteRequestModal: false,
      selectedArticle: null,
      editArticleModalRef: ref(null),
      showEditArticleModal: false,
      selectedArticleToEdit: null,
      selectedArticles: null,
      pageSettings: {pageSize: 30, pageCount: 5, pageSizes: [10, 20, 30, 50, 100]},
      filterOptions: {type: "Menu", operator: 'contains'},
      filterDefault: {operator: 'contains', params: {minLength: 2}},
      filterNumeric: {operator: 'equal'},
      toolbar: this.getToolbar(),
      editSettings: this.getEditSettings(),
selectionOptions: {type: 'Multiple', persistSelection: true, checkboxOnly: true},
      contextMenuItems: this.getContextMenu(),

      wasEditedLaterEdit: {
        params: {
          dataSource: [
            {text: 'Tak', value: 1},
            {text: 'Nie', value: 0}
          ],
          query: new Query(),
          fields: {text: 'text', value: 'value'}
        }
      },

      statusParams: {
        create: () => {
          return document.createElement('input');
        },
        read: () => {
          const selectedId = this.comboBoxObj.value;
          const selectedItem = this.quoteRequestItemsStatus.find(item => item.id === selectedId);
          return selectedItem ? selectedItem.name : '';
        },
        destroy: () => {
          this.comboBoxObj.destroy();
        },
        write: (args) => {
          this.comboBoxObj = new ComboBox({
            dataSource: this.quoteRequestItemsStatus,
            fields: {text: "name", value: "id"},
          });
          this.comboBoxObj.appendTo(args.element);
        }
      },

      currenciesParams: {
        create: () => {
          return document.createElement('input');
        },
        read: () => {
          return this.comboBoxObj.value;
        },
        destroy: () => {
          this.comboBoxObj.destroy();
        },
        write: (args) => {
          this.comboBoxObj = new ComboBox({
            dataSource: [
              {text: 'ZŁ', value: 'ZŁ'},
              {text: 'EUR', value: 'EUR'},
              {text: 'USD', value: 'USD'},
            ],
            fields: {text: "text", value: "value"},
          });
          this.comboBoxObj.appendTo(args.element);
        }
      },

      filterWarehouses: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.warehouses,
              fields: {text: 'short_name', value: 'id'},
              placeholder: 'Szukaj magazynu',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterStatuses: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.allStatuses,
              fields: {text: 'name', value: 'name'},
              placeholder: 'Szukaj statusu',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      filterUnits: {
        operator: 'contains',
        ui: {
          create: (args) => {
            let flValInput = createElement('input', {className: 'flm-input'});
            args.target.appendChild(flValInput);
            dropInstanceFilterUnits = new DropDownList({
              dataSource: this.units,
              fields: {text: 'name', value: 'id'},
              placeholder: 'Szukaj jednostki',
              popupHeight: '200px',
              allowFiltering: true
            });
            dropInstanceFilterUnits.appendTo(flValInput);
          },
          write: (args) => {
            dropInstanceFilterUnits.text = args.filteredValue || '';
          },
          read: (args) => {
            args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
          }
        }
      },

      inventoryStatusesParams: {
        create: () => {
          statusElem = document.createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj.text;
        },
        destroy: () => {
          statusObj.destroy();
        },
        write: () => {
          statusObj = new DropDownList({
            dataSource: this.inventory_statuses,
            fields: {value: 'name', text: 'name'},
            enabled: true,
            placeholder: 'Wybierz status',
            floatLabelType: 'Never'
          });
          statusObj.appendTo(statusElem);
        }
      },

      aggregateOptions: {
        columns: [
          {
            field: 'quoted_price',
            type: 'Sum',
            groupCaptionTemplate: 'Suma: ${Sum}', // Dla wierszy grupy
          },
        ],
      }
    }
  },
watch: {
    table_settings: {
        immediate: true,
        deep: true,
        handler(value) {
            this.hasTableSettings = !!(value?.settings);

            this.$nextTick(() => {
                const grid = this.$refs.quoteListGrid?.ej2Instances;

                if (grid) {
                    grid.toolbar = this.getToolbar();
                }
            });
        }
    }
},
  methods: {
  	  restoreTableIfNeeded() {
    if (this.now_restore_table !== 0) {
      return;
    }

    let grid = this.$refs.quoteListGrid;

    if (!grid || !grid.$el || !grid.ej2Instances) {
      return;
    }

    let gridName = 'grid' + grid.$el.id;

    grid.ej2Instances.enablePersistence = false;

    window.localStorage.setItem(gridName, "");

    grid.ej2Instances.destroy();

    (function stripIdsFromUrl() {
      try {
        const url = new URL(window.location.href);

        url.searchParams.delete('ids');
        url.searchParams.delete('ids[]');

        history.replaceState(
          history.state,
          '',
          url.toString()
        );
      } catch (e) {
        const href = window.location.href;

        const cleaned = href
          .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
          .replace(/[?&]$/, '');

        history.replaceState(
          history.state,
          '',
          cleaned
        );
      }
    })();
	this.applyTableSettings();
    location.reload();
  },
  getRowIndex(data) {
    const grid = this.$refs.quoteListGrid?.ej2Instances;
    const pageSize = grid?.pageSettings?.pageSize ?? 30;
    const currentPage = grid?.pageSettings?.currentPage ?? 1;
    const index = Number(data.index);
    return ((currentPage - 1) * pageSize) + (index % pageSize) + 1;
  },  
  applyTableSettings() {
    const grid = this.$refs.quoteListGrid?.ej2Instances;

    if (!grid || !this.table_settings?.settings) {
        return;
    }

    let settings;

    try {
        settings = JSON.parse(this.table_settings.settings);
    } catch (error) {
        console.error('Błąd odczytu ustawień tabeli:', error);
        return;
    }

    if (!Array.isArray(settings)) {
        return;
    }

    settings.forEach(setting => {
        if (!setting.field) {
            return;
        }

        const column = grid.columns.find(
            col => col.field === setting.field
        );

        if (!column) {
            return;
        }

        if (setting.width !== undefined) {
            column.width = setting.width;
        }

        column.visible = setting.visible !== false;
    });

    grid.refreshColumns();

    const savedFields = settings
        .filter(setting => setting.field)
        .sort((a, b) => a.index - b.index)
        .map(setting => setting.field);
    const currentFields = grid.columns
        .filter(column => column.field)
        .map(column => column.field);

    savedFields.forEach((field, targetIndex) => {
        const currentIndex = currentFields.indexOf(field);

        if (currentIndex === -1 || currentIndex === targetIndex) {
            return;
        }

        const targetField = currentFields[targetIndex];

        if (!targetField) {
            return;
        }

        grid.reorderColumns(
            field,
            targetField
        );

        currentFields.splice(currentIndex, 1);
        currentFields.splice(targetIndex, 0, field);
    });

    grid.refreshColumns();
},

      headerCellInfoEvent: function (args) {
      // pokazywanie tooltipów po najechanie na header
   /*   new Tooltip(
          {
            content: args.cell.column.headerTooltip
          },
          args.node
      );
	  */
    },

changeShowSend() {
    this.getQutoeRequestsForProject();
},
    clearSelection() {
    this.selectedRecordsToCreateOrder = [];
	this.selectedArticles = [];

	  this.$nextTick(() => {
    const grid = this.$refs.quoteListGrid?.ej2Instances;

    if (!grid) return;

    grid.clearSelection();
    grid.refresh(); 
  });
  
  
},

async onRowClick(args) {

    if (args.target?.closest('.e-checkbox-wrapper')) {
        return;
    }
    if (!args.rowData) return;

    this.quoteRequestId = args.rowData.id;
    this.quoteRequest = args.rowData;
},
	    rowSelecting(args) {
      if (this.preventRightClickSelection === true) {
        args.cancel = true; // zablokuj zmianę selekcji
        this.preventRightClickSelection = false;
      }
    },
    calculateGridHeight() {
    const topOffset =
        document.getElementById('quoteListGridId')
            ?.getBoundingClientRect().top || 200
    this.gridHeight = `${window.innerHeight - topOffset - 140}px`
},

    getEditSettings() {
      return {
        allowEditing: hasPermission('canEditQuoteRequests'),
        allowAdding: hasPermission('canEditQuoteRequests'),
        allowDeleting: hasPermission('canEditQuoteRequests'),
        showConfirmDialog: false,
        showDeleteConfirmDialog: false,
        mode: 'Batch',
        newRowPosition: 'Top',
      };
    },

    getToolbar() {
      const tools = [];

      if (hasPermission('canEditQuoteRequests')) {
        tools.push({text: 'Dodaj', prefixIcon: 'e-add', id: 'add_btn'});
        tools.push({text: 'Usuń', prefixIcon: 'e-delete', id: 'delete_btn'});
        tools.push("Update");
        tools.push("Cancel");
      }

      tools.push(
          {text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters'},
          {text: "Search", prefixIcon: 'e-search', id: "search", align: 'center'},
				{ text: "Zapisz ustawienia", prefixIcon: 'e-save', id: "save", align: 'right' });
			if (this.hasTableSettings) {	
			tools.push({ text: "Usuń ustawienia", prefixIcon: 'e-delete', id: "delete-set", align: 'right' });
			}	
			tools.push({text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right'},
          {text: "Export do Excela", prefixIcon: 'e-excelexport', id: "excelexport", align: 'right'},
          "ColumnChooser",
      )

      return tools;
    },

    clickToolbarHandler: async function (args) {
      if (args.item.text === 'Dodaj') {
        args.cancel = true;

        if (this.selectedProjectId && this.selectedTeamName)
          await this.$nextTick(() => {
            this.$refs.addQuoteRequestRef.show();
          });
      }

      if (args.item.text === 'Usuń') {
        const selectedRecords = this.$refs.quoteListGrid.getSelectedRecords();
        if (selectedRecords.length > 0) {
          selectedRecords.forEach((record) => {
            this.$refs.quoteListGrid.deleteRecord("id", record);
          });
        }
      }

      if (args.item.id === 'reset_filters') {
        this.$refs.quoteListGrid.clearFiltering();
      }
if (args.item.id === 'save') {
    const grid = this.$refs.quoteListGrid?.ej2Instances;

    if (!grid) {
        console.warn('Grid nie został znaleziony');
        this.errorMsg("Konfiguracja tabeli nie została zapisana!");
        return;
    }
    const tableId = 'quoteListGrid';
    const settings = grid.columns.map((column, index) => ({
        field: column.field || null,
        index: index,
        width: column.width,
        visible: column.visible !== false
    }));
    try {
        const response = await axios.post('/table-settings', {
            tableId: tableId,
            columns: JSON.stringify(settings)
        });
		this.hasTableSettings = true;
		  grid.toolbar = this.getToolbar();
        this.successMsg("Konfiguracja tabeli została pomyślnie zapisana!");
    } catch (error) {
        this.errorMsg("Konfiguracja tabeli nie została zapisana!");
    }
}
if (args.item.id === 'delete-set') {
    const tableId = 'quoteListGrid';
    try {
        const response = await axios.delete('/table-settings-delete',{
                data: {
                    tableId: tableId
                }
            }
        );
        this.hasTableSettings = false;
		const grid = this.$refs.quoteListGrid?.ej2Instances;

        if (grid) {
            grid.toolbar = this.getToolbar();
        }
        this.successMsg(
            "Konfiguracja tabeli została pomyślnie usunięta!"
        );
    } catch (error) {
        this.errorMsg(
            "Konfiguracja tabeli nie została usunięta!"
        );
    }
}

      if (args.item.id === 'restore') {
        let grid = this.$refs.quoteListGrid;
        let gridName = 'grid' + grid.$el.id;
        grid.ej2Instances.enablePersistence = false;
        window.localStorage.setItem(gridName, "");
        grid.ej2Instances.destroy();
		this.applyTableSettings();
        location.reload();
      }

if (args.item.id === 'excelexport') {
    const grid = this.$refs.quoteListGrid;

    const hiddenColumns = [
        'article_files',
        'required_project_files',
        'files'
    ];

    hiddenColumns.forEach(field => {
        grid.getColumnByField(field).visible = false;
    });

    grid.refreshColumns();

    grid.excelExport({
        fileName: 'zapytania ofertowe.xlsx'
    }).then(() => {
        hiddenColumns.forEach(field => {
            grid.getColumnByField(field).visible = true;
        });

        grid.refreshColumns();
    });
}
    },
getContextMenu() {
  const contextMenu = [];
  if (hasPermission('canEditQuoteRequests')) {
    contextMenu.push(
        {text: 'Wyślij zapytanie', target: '.e-content', id: 'send_quote_request'},
    );
  }

if (hasPermission('canEditOrders')) {
    contextMenu.push(
        {text: 'Utwórz zamówienie', target: '.e-content', id: 'create_order'},
        {text: 'Dodaj do zamówienia', target: '.e-content', id: 'create_to_order'},
    );
}
  contextMenu.push(
      {text: 'Przejdź to zapotrzebowania', target: '.e-content', id: 'go_to_required'},
  );

  return contextMenu;
},

onContextMenuOpen(args) {
    const selected = this.$refs.quoteListGrid?.getSelectedRecords() || [];

    if (!selected.length) {
        args.cancel = true;
        return;
    }

    const menu = this.$refs.quoteListGrid
        .ej2Instances.contextMenuModule.contextMenu;

      menu.showItems(['send_quote_request', 'create_order', 'create_to_order', 'go_to_required'], true);

    if (selected.length === 1) {
       menu.showItems(['send_quote_request', 'create_order', 'create_to_order','go_to_required'], true);
    }
	else if (selected.length > 1){
        menu.showItems(['create_order', 'create_to_order'], true);
        menu.hideItems(['send_quote_request', 'go_to_required'], true);
    }
    else {
         menu.hideItems(['create_order', 'create_to_order', 'send_quote_request', 'go_to_required'], true);
    }
 },
 async    clickContextMenuHandler(args) {
	
if (args.item.id === 'create_order') {
    const selectedQuotes = this.$refs.quoteListGrid.getSelectedRecords() || [];
    this.selectedRecordsToCreateOrder = [];
	 	
    for (const quote of selectedQuotes) {
        const response = await axios.post(
            route('quote-request-items-list.get', {
                quoteRequestId: quote.id
            })
        );
this.selectedRecordsToCreateOrder.push(
    ...response.data.map(item => ({
        ...item,
        article_id: item.article_id,
        article: item.article,
        quantity_required: item.quantity_required,
        delivery_date_deadline: item.delivery_date_deadline,
        comments: item.comment,
        quote_request_item_id: item.id,
        required_project_items_id: item.required_project_items_id,
    }))
);
this.showAddOrderModal = true;
 }
    this.$nextTick(() => {

        this.$refs.addOrderModalRef.show();
    });
}

if (args.item.id === 'create_to_order') {
    const selectedQuotes = this.$refs.quoteListGrid.getSelectedRecords() || [];
    this.selectedRecordsToCreateOrder = [];
    for (const quote of selectedQuotes) {
        const response = await axios.post(
            route('quote-request-items-list.get', {
                quoteRequestId: quote.id
            })
        );
this.selectedRecordsToCreateOrder.push(
    ...response.data.map(item => ({
        ...item,
        article_id: item.article_id,
        article: item.article,
        quantity_required: item.quantity_required,
        delivery_date_deadline: item.delivery_date_deadline,
        comments: item.comment,
        quote_request_item_id: item.id,
        required_project_items_id: item.required_project_items_id,
    }))
);
 }
    this.$nextTick(() => {
        this.$refs.addToOrderModalRef.show();
    });
}

      if (args.item.id === 'send_quote_request') {
        this.selectedArticles = this.$refs.quoteListGrid.getSelectedRecords();
        this.$nextTick(() => {
          this.$refs.sendQuoteRequestModalRef.show();
        });
      }

      if (args.item.id === 'go_to_required') {
        let required_project_ids = this.$refs.quoteListGrid.getSelectedRecords()
            .flatMap(r => {
              const v = r?.required_project_id;
              if (v == null || v === '') return [];
              if (Array.isArray(v)) return v;                 // gdyby już było tablicą
              return String(v).split(',');                    // "144, 10,103" -> ["144"," 10","103"]
            })
            .map(s => String(s).trim())
            .filter(s => s !== '')
            .map(n => Number(n))
            .filter(n => Number.isFinite(n));

        required_project_ids = [...new Set(required_project_ids)];
        router.get(route('requiredProjectItems.index'), {ids: required_project_ids.join(',')}, {
          preserveState: true, preserveScroll: true, replace: true
        });
      }
    },

    updateSelectedProject(event) {
      this.selectedProjectId = Number(event.target.value);
      this.teams = null;
      this.selectedTeamName = null;
      if (this.selectedProjectId) {
        this.updateTeams()
      }

      this.getQutoeRequestsForProject();
    },

    updateTeams() {
      if (this.selectedProjectId) {
        const project = this.projects.find(project => project.id === Number(this.selectedProjectId));
        if (project) {
          this.teams = project.teams;
          this.selectedTeamName = null;
        }
      } else {
        this.teams = [];
        this.selectedTeamName = null;
      }
    },

    updateSelectedTeam(event) {
      this.selectedTeamName = event.target.value;
      this.getQutoeRequestsForProject();
    },

    getQutoeRequestsForProject() {
      sessionStorage.setItem('selectedProjectId', this.selectedProjectId);
      sessionStorage.setItem('selectedTeam', this.selectedTeamName);

this.quoteRequestsDataManager = new DataManager({
    url: route('quoteRequests.getList', {
        project: this.selectedProjectId,
        team: this.selectedTeamName,
        sendShown: this.showSend
    }),
    adaptor: new WebMethodAdaptor(),
    batchUrl: route('quoteRequests.saveChanges'),
    updateUrl: route('quoteRequests.updateChanges'),
    crossDomain: true,
    headers: [
        { 'X-CSRF-TOKEN': usePage().props.csrf_token }
    ],
});

  this.$nextTick(() => {
    setTimeout(() => {
        this.applyTableSettings();
      this.$refs.quoteListGrid?.ej2Instances?.refresh();
    }, 100);
  });
    },

    dateFormatter(field, data) {
      const date = data.created_at ? data.created_at : null;
      if (date) {
        try {
          return moment(date).format('DD.MM.YYYY HH:mm:ss');
        } catch (error) {
          return data
        }
      }

      return '';
    },

    queryCellInfo(args) {
      // Sprawdź, czy artykuł został usunięty
      if (args.column.field === "article.catalog_number" || args.column.field === "article.model") {
        if (args.data.article && args.data.article.deleted_at) {
          args.cell.setAttribute('title', 'Ten artykuł został usunięty!');
          args.cell.classList.add("deleted-article");
        }
      }
    },

    async onRowSelected(args) {
      this.quoteRequestId = args.data.id;
      this.quoteRequest = args.data;
      this.selectedQuoteRequest = args.data;
    },

    onKeyDown: function (args) {
      let keyCode = args.which || args.keyCode;
      let isCtrlKey = (args.ctrlKey || args.metaKey) ? true : ((keyCode === 17));

      // code 83 to 'S'
      if (isCtrlKey && keyCode === 83) {
        args.preventDefault();

        // aktualizuj
        let toolbar = document.getElementsByClassName('e-toolbar-left')[0];
        let buttons = toolbar.querySelectorAll('.e-toolbar-item');
        let updateButton = buttons[2].querySelector('button');
        if (updateButton) {
          updateButton.click();

        }
      }
    },

    actionBeginHandler(args) {
      //
      // WYSZUKIWARKA- wyszukiwanie wielu wartości z separatorem (przecinek
      //
      if (args.requestType === 'searching') {
        const keys = args.searchString.split(';');
        let flag = true;
        let predicate;

        if (this.$refs.quoteListGrid.ej2Instances.searchSettings.key !== '') {
          this.values = args.searchString;
          keys.forEach((key) => {
            this.$refs.quoteListGrid.ej2Instances.getColumns().forEach((col) => {
              if (flag) {
                predicate = new Predicate(col.field, 'contains', key, true);
                flag = false;
              } else {
                let predic = new Predicate(col.field, 'contains', key, true);
                predicate = predicate.or(predic);
              }
            });
          });

          this.$refs.quoteListGrid.ej2Instances.query = new Query().where(predicate);
          this.$refs.quoteListGrid.ej2Instances.searchSettings.key = '';
          this.refresh = true;
          this.valueAssign = true;
          this.removeQuery = true;
          this.$refs.quoteListGrid.ej2Instances.refresh();
        } else {
          this.$refs.quoteListGrid.ej2Instances.searchSettings.key = '';
          this.refresh = true;
          this.valueAssign = true;
          this.removeQuery = true;
          this.$refs.quoteListGrid.ej2Instances.refresh();
        }
      }
    },

    actionCompleteHandler(args) {
      //
      // WYSZUKIWARKA - wyszukiwanie wielu wartości z separatorem (przecinek
      //
      if (args.requestType === "refresh") {
        const searchBar = document.getElementById(
            this.$refs.quoteListGrid.ej2Instances.element.id + "_searchbar"
        );

        if (this.valueAssign) {
          searchBar.value = this.values; // Przywraca wartość tylko raz
          this.valueAssign = false;
        }

        // Jeśli pasek wyszukiwania jest pusty i `removeQuery` jest aktywny, to resetujemy tylko raz
        if (searchBar.value.trim() === "" && this.removeQuery) {
          this.$refs.quoteListGrid.ej2Instances.query = new Query();
          this.removeQuery = false;
          this.$refs.quoteListGrid.ej2Instances.refresh();
        }
      }

      if (args.requestType === "batchsave") {
        if (args.changes && args.changes.changedRecords) {
          this.successMsg("Dane zostały pomyślnie zapisane!");
        } else if (args.error) {
          this.errorMsg("Wystąpił błąd podczas zapisu danych: " + args.error);
        }
      }
    },

    refreshGrids() {
      if (this.$refs.quoteListGrid) {
        this.$refs.quoteListGrid.ej2Instances.refresh();
      }

      if (this.$refs.quoteRequestItemsRef) {
        this.$refs.quoteRequestItemsRef.ej2Instances.refresh();
      }
    },

    showAttachmentsModal(article) {
      this.selectedArticle = {files: article};
      this.showFilesModal = true;
    },

    showRequiredAttachmentsModal(article) {
      this.selectedArticle = {files: article};
      this.showRequiredFilesModal = true;
    },

    showQuoteRequestAttachmentsModal(article) {
      this.selectedArticle = article;
      this.showQuoteRequestModal = true;
    },

    successMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'success',
        title: 'Sukces!',
        html: resp,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },

    errorMsg(resp) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: 'warning',
        title: 'Błąd!',
        html: resp,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    },

    formatDeliverers(data) {
      // Paruj JSON i formatuj jako ciąg znaków
      try {
        const names = JSON.parse(data.deliverers_short_names);
        return names.join(', ');
      } catch (e) {
        // Jeśli dane nie są poprawnym JSON-em, zwróć je bez zmian
        return data.deliverers_short_names;
      }
    }

  }
}
</script>

<style scoped>
.not-editable {
  color: orangered;
}
.mobile-filter-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 320px;
  height: 100vh;
  background: #fff;
  z-index: 1060;
  transform: translateX(-100%);
  transition: 0.25s ease;
  box-shadow: 0 0 20px rgba(0,0,0,0.2);
  padding: 16px;
}

.mobile-filter-panel.show {
  transform: translateX(0);
}
</style>